import React from 'react'
import { Link } from 'react-router-dom'
import BreadCrumb from '../../../components/BreadCrumb'

export default function TrainingBanner({data, breadcrumb}) {

    return (
        <>
            <section className="training-banner">
                 <img src={data?.image} alt="Banner"  className="img-responsive" />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <div className="training-text">
                               {breadcrumb && <BreadCrumb data={breadcrumb} />}
                                <h1 className="heading">{data?.heading}</h1>
                                 <div className="des" dangerouslySetInnerHTML={{ __html: data?.description }} />
                                <div className="training-btn">
                                <Link className="default-btn" to={data?.link} ><span>{data?.buttonText}</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
